import { CSPUrlsMap } from '../../routes/CSPUrlsMap';

export const PIACSPConfig = {
  cspConfiguration: {
    partner: 'pia',
    partnerTitle: 'PIA Pet Insurance',
    auth0Config: {
      sit: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'pia-sit-petportal-auth.petsure.com.au',
        appClientId: '9rQZzxd4aWsZN8EgmNJ7VLnv3dOBA32O',
        cspMfaUrl: 'https://pia-sit-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-pia-sys.petsure.com.au/account-verification'
      },
      uat: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'pia-uat-petportal-auth.petsure.com.au',
        appClientId: 'd6mmfzZALjGkHhWzzlxafCJW7nvMSPfI',
        cspMfaUrl: 'https://pia-uat-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-pia-uat.petsure.com.au/account-verification'
      },
      preprod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'pia-preprod-petportal-auth.petsure.com.au',
        appClientId: 'FY2oo64v7SHzUC6kEpr87lfgUv4lfdUd',
        cspMfaUrl: 'https://pia-preprod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-pia-preprod.petsure.com.au/account-verification'
      },
      prod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'pia-petportal-auth.petsure.com.au',
        appClientId: 'rzvE32ZBzZRSLH4KHRRXR5qyrgRhpIYk',
        defaultAudience: 'https://cspmiddlewareapi',
        cspMfaUrl: 'https://pia-prod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-petinsuranceaustralia.petsure.com.au/account-verification'
      }
    },
    liveVetConfig: {
      sit: {
        vetChatAppModule: 'petinsuranceaustralia.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      uat: {
        vetChatAppModule: 'petinsuranceaustralia.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      preprod: {
        vetChatAppModule: 'petinsuranceaustralia.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      prod: {
        vetChatAppModule: 'petinsuranceaustralia.vetchat.com.au',
        vetChatUrl: 'https://livevet.vetchat.com.au',
        vetChatConsultationUrl: 'https://livevet.vetchat.com.au/consult'
      }
    },
    creditCardConfig: {
      sit: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      uat: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      preprod: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      prod: {
        formUrl: 'https://quickweb.westpac.com.au/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      paynowSupplierBusinessCode: 'RTCC',
      paynowSupplierBusinessCodePetsure: 'RTCC_PS'
    },
    bannerImage: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/bg/bg_pia.webp',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/bg/bg_pia.webp'
    },
    customFaviconUrl: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/favicon/pia_favicon.webp',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/favicon/pia_favicon.webp'
    },
    headerLogo: {
      nonprod: {
        imageUrl:
          'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/logo/PIA_header_logo_whitefilled.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      },
      prod: {
        imageUrl:
          'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/logo/PIA_header_logo_whitefilled.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      }
    },
    footerLogo: {
      nonprod: {
        imageUrl:
          'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/footer/PIA_footer_logo_grey.png',
        imageTitle: 'Pet Insurance Australia',
        imageTitleDescription: 'Pet Insurance Australia'
      },
      prod: {
        imageUrl:
          'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/footer/PIA_footer_logo_grey.png',
        imageTitle: 'Pet Insurance Australia',
        imageTitleDescription: 'Pet Insurance Australia'
      }
    },
    termsOfUseUrl:
      'https://petcdnstore.blob.core.windows.net/csp-common/pdfs/terms_of_use/Customer_Portal_Terms_of_Use_092024.pdf',
    header: {
      layoutConfig: {
        small: 'hamburger',
        large: 'horizontal'
      }
    },
    faqRedirection: {
      excessTooltip: {
        category: 'claims',
        question: 'How is my claim benefit calculated?'
      },
      editName: {
        category: 'policy management',
        question: `Why can't I edit my name in the Pet Portal?`
      },
      addYourVet: {
        category: 'getting started',
        question: 'Adding your vet to your account'
      }
    },
    isLiteModeEnabled: false,
    isLecBrand: false,
    gtm: {
      id: 'GTM-56PVBTDH',
      dataLayer: 'dataLayer'
    },
    seo: {
      title: 'PIA - Pet Portal Login',
      description:
        'Access your PIA Pet Portal to manage your pet policy, access 24/7 Live Vet support and to submit and track your claims.'
    }
  }
};
